import React from "react"

interface MainProps {
	children: React.ReactNode
}

const Main = ({children}: MainProps) => {
	return <section className='layout-main'>{children}</section>
}

export default Main
